export { InstructionDownload } from "./instruction_download";
export { ClientReview } from "./client_review";
export { CountdownTwo } from "./countdown_two";
export { FAQSection } from "./faq";
export { InstructionGallery } from "./instruction_gallery";
export { PartnerSection } from "./partner/partner";
export { PartnerGrid } from "./partner_grid";
export { TestimonialSection } from "./testimonial/testimonial";
